// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lF","subText":"lG"};